/**
 * Path of the payment completion page hosted by this app.
 *
 * OPI (and any integration that cannot supply its own return_url) sets the
 * payment's `return_url` to this path on our own domain, e.g.
 * `https://p-staging.kody.com/payment-complete`. kp-core requires `return_url`
 * to be present, so this agreed value satisfies that constraint while signalling
 * to the frontend that the shopper should be shown our own completion page
 * instead of being redirected out to a merchant site.
 */
export const PAYMENT_COMPLETE_PATH = '/payment-complete';
